import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UsageReport } from './usage-report.model';

@Injectable()
export class UsageReportsService {

    constructor(private http: HttpClient) {
    }

    async all(): Promise<UsageReport[]> {
        return this.http.get<UsageReport[]>('usage-reports').toPromise();
    }

    async getReportContent(usageReport: UsageReport): Promise<Blob> {
        const reportData = await this.http.get('usage-report', {
            headers: new HttpHeaders({
                "Content-Type": "text/csv",
                "Accept": "text/csv"
            }),
            params: {
                "councilid": usageReport.councilId,
                "year": usageReport.year.toString(),
                "month": usageReport.month.toString(),
            },
            responseType: "blob",
            withCredentials: true,
        }).toPromise();

        return new Blob([reportData]);
    }
}
